// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { customerCardStyles } from "@conklin/Overrides/Components/CustomerCard";
import { color, iconLinkCommonStyles, mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import Edit from "@insite/mobius/Icons/Edit";
import { css } from "styled-components";

customerCardStyles.addressGridItem = {
    width: [12, 6, 6, 6, 6],
};

customerCardStyles.actionsGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        justify-content: flex-end;
    `,
};

customerCardStyles.actionsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;

        ${xScreen("lte", "xs")} {
            flex-direction: row;
            justify-content: space-between;
            height: auto;
            width: 100%;
        }
    `,
};

customerCardStyles.selectButton = {
    variant: "primary",
    sizeVariant: "small",
    css: css`
        margin-bottom: 8px;
    `,
};

customerCardStyles.editLink = {
    ...mergeWithCss(iconLinkCommonStyles(Edit), {
        css: css`
            display: flex;
            justify-content: center;
            ${xScreen("lte", "xs")} {
                margin-top: 0;
            }
        `,
    }),
};

customerCardStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid ${color("common.border")};
    `,
};

customerCardStyles.addressWrapper = {
    css: css`
        padding: 16px;
    `,
};

customerCardStyles.actionsContainer = {
    css: css`
        padding: 16px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
    `,
};
